/**
 * App-wide mobile ticker SSOT (design r2).
 * Sticky localStorage; same key as desktop Explorer for symbol continuity.
 */

const SYMBOL_KEY = 'fzn.explorer.symbol';
const SYMBOL_PATTERN = /^[A-Z0-9.^-]{1,12}$/;
const DEFAULT_SYMBOL = 'NVDA';

const listeners = new Set<() => void>();

let symbol: string = readStoredSymbol() || DEFAULT_SYMBOL;

function notify(): void {
  for (const fn of listeners) fn();
}

function readStoredSymbol(): string {
  try {
    const stored = (localStorage.getItem(SYMBOL_KEY) ?? '').toUpperCase();
    if (!SYMBOL_PATTERN.test(stored)) return '';
    return stored;
  } catch {
    return '';
  }
}

function writeStoredSymbol(value: string): void {
  try {
    if (value) localStorage.setItem(SYMBOL_KEY, value);
    else localStorage.removeItem(SYMBOL_KEY);
  } catch {
    /* private mode */
  }
}

function normalize(raw: string): string | null {
  const s = raw.trim().toUpperCase();
  if (!SYMBOL_PATTERN.test(s)) return null;
  return s;
}

export const mobileTickerStore = {
  getSymbol(): string {
    return symbol;
  },

  setSymbol(raw: string): void {
    const next = normalize(raw);
    if (!next || next === symbol) return;
    symbol = next;
    writeStoredSymbol(next);
    notify();
  },

  subscribe(cb: () => void): () => void {
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  },

  getSnapshot(): string {
    return symbol;
  },
};
